import { createQueryKeys } from '@lukemorales/query-key-factory'

import { getFamilyNotes } from '~/api'
import {
  getFamilyById,
  getSnapshotsByFamilyId,
  getSurveyDefinitionsByFamilyId,
} from '~/features/families/common/services'
import { getProjectsByOrgsAndHub } from '~/services/projects-services'

export const familiesQueries = createQueryKeys('families', {
  family: (familyId: number | undefined) => ({
    queryKey: [{ familyId }],
    queryFn: async () => {
      if (!familyId) {
        return await Promise.reject(new Error('FamilyId must be provided'))
      }
      return await getFamilyById(familyId)
    },
  }),
  snapshots: (familyId: number | undefined) => ({
    queryKey: [{ familyId }],
    queryFn: async () => {
      if (!familyId) {
        return await Promise.reject(new Error('FamilyId must be provided'))
      }
      return await getSnapshotsByFamilyId(familyId)
    },
  }),
  surveyDefinitionsByFamilyId: (familyId: number | undefined) => ({
    queryKey: [{ familyId }],
    queryFn: async () => {
      if (!familyId) {
        return await Promise.reject(new Error('FamilyId must be provided'))
      }
      return await getSurveyDefinitionsByFamilyId(familyId)
    },
  }),
  notes: (familyId: number | undefined) => ({
    queryKey: [{ familyId }],
    queryFn: async () => {
      if (!familyId) {
        return await Promise.reject(new Error('FamilyId must be provided'))
      }
      const response = await getFamilyNotes(familyId)
      return response.data.data.notesByFamily
    },
  }),
  projects: (organizationId: number | undefined) => ({
    queryKey: [{ organizationId }],
    queryFn: async () => {
      if (!organizationId) {
        return await Promise.reject(
          new Error('OrganizationId must be provided'),
        )
      }

      const response = await getProjectsByOrgsAndHub([organizationId])
      return response.data.data.projectsByOrganization
    },
  }),
})
